import { render, staticRenderFns } from "./ArticlesSection.vue?vue&type=template&id=4488361d&scoped=true&"
import script from "./ArticlesSection.vue?vue&type=script&lang=js&"
export * from "./ArticlesSection.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSection.vue?vue&type=style&index=0&id=4488361d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488361d",
  null
  
)

export default component.exports